import { END_POINTS } from '../helpers';
import { VehicleModelData, CommonBody } from '../types/General';
import emptySplitApi from '../utils/rtk';

type CommonResponse = {
  statusCode: number;
  message: string;
};

type GetVehicleModelResponse = {
  count: number;
  data: VehicleModelData[];
};

export const trimApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getTrim: builder.query<
      CommonResponse & { data: GetVehicleModelResponse },
      {
        page: number;
        limit: number;
        trimType: number;
        search: string;
        vehicleId?: string;
      }
    >({
      query: ({ page, limit, search, vehicleId, trimType }) => ({
        url: `${END_POINTS.getTrim}?page=${page}&trimType=${trimType}&limit=${limit}${
          search?.length ? `&search=${search}` : ''
        }${vehicleId ? `&vehicleId=${vehicleId}` : ''}`,
        method: 'GET',
      }),
    }),

    deleteTrim: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteTrim}/${id}`,
        method: 'DELETE',
      }),
    }),
    getTrimById: builder.query<CommonResponse & { data: VehicleModelData }, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.getTrimById}/${id}`,
        method: 'GET',
      }),
    }),

    addTrim: builder.mutation<CommonResponse & { data: VehicleModelData }, { body: CommonBody }>({
      query: ({ body }) => ({
        url: `${END_POINTS.addTrim}`,
        method: 'POST',
        body,
      }),
    }),
    updateTrim: builder.mutation<
      CommonResponse & { data: VehicleModelData },
      { body: CommonBody; id: string | undefined }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateTrim}/${id}`,
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const {
  useAddTrimMutation,
  useUpdateTrimMutation,
  useLazyGetTrimQuery,
  useLazyDeleteTrimQuery,
  useLazyGetTrimByIdQuery,
} = trimApi;
